module.exports = __webpack_public_path__ + "static/media/tesco.b853ef6e.png";